import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LoginRequestPayload } from '../../shared/models/login-request-payload.model';
import { Observable, tap } from 'rxjs';
import { LoginResponsePayload } from '../../shared/models/login-response-payload.model';
import { User } from '../../shared/models/users.models';
import { USER_META } from '../../shared/constants/user-meta.const';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);

  private router = inject(Router);

  private user = signal<LoginResponsePayload | null>(null);

  login(loginRequest: LoginRequestPayload): Observable<LoginResponsePayload> {
    return this.http.post<LoginResponsePayload>('api/auth/token', loginRequest).pipe(
      tap((res) => {
        this.user.set(res);
        localStorage.setItem(USER_META, JSON.stringify(res));
      }),
    );
  }

  getUser(): LoginResponsePayload | null {
    if (!this.user()) {
      const stored = localStorage.getItem(USER_META);
      if (stored) this.user.set(JSON.parse(stored));
    }
    return this.user() || null;
  }

  updateUserScopes(scopes: string[]) {
    this.user.update((u) => {
      if (u) u.scopes = scopes;
      return u;
    });
    localStorage.setItem(USER_META, JSON.stringify(this.user()));
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem(USER_META);
  }

  logout(): void {
    localStorage.removeItem(USER_META);
    this.user.set(null);
    this.router.navigate(['/login']);
  }

  getUsers(data?: { page?: number; search?: string }): Observable<[User[], number]> {
    let params = new HttpParams().set('page', data?.page || 1);

    if (data?.search) params = params.set('search', data.search);

    return this.http.get<[User[], number]>('/auth/users', { params });
  }
}
